import AppIndex from "./appindex/AppIndex";

const App = () => {
  return <AppIndex />;
};

export default App;
